
const endView = {

	init() {

		// Toon of verberg het blok voor overlappend dienstverband op basis van de begindatum voor een nieuw dienstverband en de einddatum van reeds bestaande dienstverbanden.
		$('#beeindig-melding-button').click(function(e) {
			e.preventDefault();
			$.getJSON($(this).attr('href'), function(data) {
				if (data != false) {
					$('#modalBeeindigMelding').modal('toggle');
				}
			});
		});

		// Open modal waarschuwing dat er een lopende melding is
		if ($('#modalBeeindigMelding').length) {
			$('#modalBeeindigMelding').modal({
				keyboard: false,
				backdrop: 'static'
			});
		}

	}

};

export default endView;
